import React, {Component} from 'react';
import {NavItem, Nav} from 'react-bootstrap';


class HeaderLinks extends Component {
    render() {
        return (
            <div>
                <Nav pullRight>
                    <NavItem eventKey={3} href="#"
                             onClick={() => this.props.logout()}>
                        Log out
                    </NavItem>
                </Nav>
            </div>
        );
    }
}

export default HeaderLinks;



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx